import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute right-4 bottom-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-custom-primaryBlue rounded-full p-1 flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "white",
    class: "bi bi-check2",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]


import MapIcon from "@/components/Icons/MapIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapCaseForMenu',
  props: {
    active: { type: Boolean },
    color: {},
    backgroundColor: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative p-2 m-2 flex justify-center items-center",
    style: _normalizeStyle({ 'background-color': props.backgroundColor })
  }, [
    _createVNode(MapIcon, {
      color: props.color
    }, null, 8, ["color"]),
    (props.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ], 4))
}
}

})